import angular from 'angular';

import component from './menu-details.component';

const menuDetails = angular
    .module('control-room.menus.components.menu-details', [])
    .component('crMenuDetails', component);

export default menuDetails;
